import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import BottomNavigation from "./BottomNavigation";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../store/slices/userSlice";
import Splash from "./Splash";
import useUser from "../hooks/useUser";
import useAddress from "../hooks/useAddress";
import { useUserPersistence } from "../hooks/useUserPersistence";
import { useBackButtonHandler } from "../hooks/useBackButtonHandler";

const LayoutContent = () => {
  const token = useSelector((state) => state?.user?.token);

  return (
    <div className="min-h-screen w-full bg-primary-50 page flex flex-col">
      <div className="flex flex-1 pb-16">
        <Outlet />
      </div>
      {token && <BottomNavigation />}
    </div>
  );
};

const Layout = () => {
  const [showSplash, setShowSplash] = useState(true);
  const reduxToken = useSelector((state) => state?.user?.token);
  const dispatch = useDispatch();
  const { fetchUserDetails } = useUser();
  const token = reduxToken || localStorage.getItem("token");

  // Initialize user-specific persistence
  useUserPersistence();

  // Initialize smart back button handler
  useBackButtonHandler();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.__splashDone = true;
      window.dispatchEvent(new Event('splashDone'));
      setShowSplash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (token) {
      dispatch(setToken(token));
    }
  }, [reduxToken]);

  // Long polling: fetch user details every 10 seconds
  useEffect(() => {
    let intervalId;
    if (token) {
      fetchUserDetails(); // Initial fetch
      intervalId = setInterval(fetchUserDetails, 10000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [token, fetchUserDetails]);

  if (showSplash) return <Splash />;

  return <LayoutContent />;
};

export default Layout;
